import { useState } from "react";

import { getTheme } from "../util/localStorage.util";
import { ThemeList } from "../enum/enum";

export function useIsDarkModeEnabled() {
  const [isDarkModeEnabled] = useState(getTheme() === ThemeList.DARK);

  return isDarkModeEnabled;
}
